import {Translations} from './backendTranslations-types';

type TranslationsLoadedAction = {
    readonly type: 'TRANSLATIONS_LOADED';
    readonly translations: Translations;
};
export type TranslationsAction = TranslationsLoadedAction;

export const translationsLoaded = (data: Translations): TranslationsLoadedAction => {
    return {
        type: 'TRANSLATIONS_LOADED',
        translations: data
    };
};
